<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 16.75C13.728 16.75 16.75 13.728 16.75 10C16.75 6.27208 13.728 3.25 10 3.25C6.27208 3.25 3.25 6.27208 3.25 10C3.25 13.728 6.27208 16.75 10 16.75Z" 
    stroke="#B38600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 16.75C13.728 16.75 16.75 13.728 16.75 10C16.75 6.27208 13.728 3.25 10 3.25C6.27208 3.25 3.25 6.27208 3.25 10C3.25 13.728 6.27208 16.75 10 16.75Z" 
    stroke="url(#gradient-0)" stroke-opacity="0.44" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0001 6.625V5.875M10.0001 13.375V14.125M11.5001 7.75C10.7501 6.25 8.12512 6.66425 8.12512 8.33333C8.12512 10.5057 11.8751 9.48467 11.8751 11.6094C11.8751 13.2931 8.87512 13.75 8.12512 12.25" 
    stroke="#B38600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0001 6.625V5.875M10.0001 13.375V14.125M11.5001 7.75C10.7501 6.25 8.12512 6.66425 8.12512 8.33333C8.12512 10.5057 11.8751 9.48467 11.8751 11.6094C11.8751 13.2931 8.87512 13.75 8.12512 12.25" 
    stroke="url(#gradient-1)" stroke-opacity="0.44" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
      <linearGradient id="gradient-0" x1="10" y1="16.75" x2="10" y2="3.25" gradientUnits="userSpaceOnUse">
        <stop stop-color="#B38600" stop-opacity="0" />
        <stop offset="1" stop-color="#B38600" />
      </linearGradient>
      <linearGradient id="gradient-1" x1="10.0001" y1="14.125" x2="10.0001" y2="5.875" gradientUnits="userSpaceOnUse">
        <stop stop-color="#B38600" stop-opacity="0" />
        <stop offset="1" stop-color="#B38600" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'BountyPayoutGradientIcon',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    }
  }
}
</script>

<style scoped></style>